import { thunk } from 'easy-peasy';
import { API } from '@aws-amplify/api';
import awsApiConfig from './config/awsApiConfigure';

API.configure(awsApiConfig);

const SupplierMiddleware = {
  //✨✨==========================================✨✨
  //            GET LIST SUPPLIERS
  //✨✨==========================================✨✨
  getListSuppliers: thunk(async (actions, payload, { getStoreActions, getStoreState }) => {
    // body request
    const graphqlQuery = `
      query MyQuery {
        listTypeCompanies(filter: {name: {eq: "${payload}"}} limit: 500000) {
          items {
            id
            name
            companies {
              items {
                address
                ctm
                id
                mail
                name
                phone
                siret
                type
                worksites {
                  items {
                    id
                  }
                }
              }
            }
          }
        }
      }
    `;
    getStoreActions().global.setActivity(true);
    try {
      const query = await API.graphql({
        query: graphqlQuery,
      });
      const myData = query.data?.listTypeCompanies.items[0].companies.items;
      console.log('DATA', myData);
      return myData;
    } finally {
      getStoreActions().global.setActivity(false);
    }
  }),

  //✨✨==========================================✨✨
  //            GET SUPPLIER
  //✨✨==========================================✨✨
  getSupplier: thunk(async (actions, payload, { getStoreActions, getStoreState }) => {
    // body request
    const graphqlQuery = `
    query MyQuery {
        getCompany(id: "${payload}") {
          address
          ctm
          id
          mail
          name
          phone
          siret
          type
        }
      }`;
    getStoreActions().global.setActivity(true);
    try {
      const query = await API.graphql({
        query: graphqlQuery,
      });
      const myData = query.data?.getCompany;
      return myData;
    } finally {
      getStoreActions().global.setActivity(false);
    }
  }),

  //✨✨==========================================✨✨
  //            CREATE SUPPLIER
  //✨✨==========================================✨✨
  createSupplier: thunk(async (actions, payload, { getStoreActions, getStoreState }) => {
    // body request
    const graphqlQuery = `
    mutation MyMutation {
      createCompany(input: {
        address: "${payload.address}", 
        mail: "${payload.mail}", 
        name: "${payload.name}", 
        phone: "${payload.phone}", 
        siret: "${payload.siret}",
        type: "${payload.type}",
        typeCompanyCompaniesId: "${payload.id_type_Company}",
        ${payload.typeClient === 'CTM' ? 'ctm: true' : 'ctm: false'}
      })
      {
          id
      }
    }`;
    getStoreActions().global.setActivity(true);
    try {
      const query = await API.graphql({
        query: graphqlQuery,
      });
      const myData = query.data?.createCompany;
      return myData;
    } finally {
      getStoreActions().global.setActivity(false);
    }
  }),

  //✨✨==========================================✨✨
  //            UPDATE SUPPLIER
  //✨✨==========================================✨✨
  updateSupplier: thunk(async (actions, payload, { getStoreActions, getStoreState }) => {
    // body request
    const graphqlQuery = `
    mutation MyMutation {
      updateCompany(input: {
        id: "${payload.id}", 
        name: "${payload.name}",
        siret: "${payload.siret || ''}",
        address: "${payload.address}", 
        mail: "${payload.mail}", 
        phone: "${payload.phone}",
        type: "${payload.type}",
        ${payload.typeClient === 'CTM' ? 'ctm: true' : 'ctm: false'}
      })
      {
          id
      }
    }`;
    getStoreActions().global.setActivity(true);
    try {
      const query = await API.graphql({
        query: graphqlQuery,
      });
      const myData = query.data?.updateCompany;
      return myData;
    } finally {
      getStoreActions().global.setActivity(false);
    }
  }),

  //✨✨==========================================✨✨
  //          DELETE SUPPLIER
  //✨✨==========================================✨✨
  deleteSupplier: thunk(async (actions, payload, { getStoreActions, getStoreState }) => {
    // body request
    const graphqlQuery = `
    mutation MyMutation {
      deleteCompany(input: {id: "${payload.id}"}) 
      {
        id
      }
    }
    `;
    getStoreActions().global.setActivity(true);
    try {
      const query = await API.graphql({
        query: graphqlQuery,
      });
      const myData = query.data?.deleteCompany;
      return myData;
    } finally {
      getStoreActions().global.setActivity(false);
    }
  }),
};

export default SupplierMiddleware;

